import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { PreduaService } from '../../solicitudes/predua/predua.service';
import { ProductosService } from '../../solicitudes/productos/productos.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { TMedioTransportePreDuaViewModel, TPartidaPreduaViewModel, TPosicionamientoPreduaViewModel } from './predua.types';

@Component({
    selector: 'app-predua-edit',
    templateUrl: './predua-edit.component.html',
})
export class PreduaEditComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    //@ViewChild('tableSearch2') turboTable2: Table;

    idSolicitud: number;
    EsSolicitante = true;
    NombreInspector = '';
    solicitudPredua: TMedioTransportePreDuaViewModel;
    partidas: TPartidaPreduaViewModel[];
    strMatriculas = '';
    posicionamientopredua: TPosicionamientoPreduaViewModel[];
    mrn = '';
    _parametros = '';
    listOperacion: Tc[];
    //listSolicitudPartidasPreduaCollection$: Observable<TProductoSolicitudViewModel[]>;

    IdEstadoSolicitud: number;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    TipoSolicitudDescripcion: string;
    EstadoSolicitudDescripcion: string;
    EsPredua = false;

    cols: any[];
    //cols2: any[];
    public selectedColumns: any[];
    //public selectedColumns2: any[];

    public isCollapsedExportador = false;
    public isCollapsedImportador = false;
    public isCollapsedLugaresMercancia = false;
    public isCollapsedOtrosDatos = false;
    public isCollapsedDatosPreDua = false;
    public isCollapsedContenedores = false;
    public isCollapsedPartidasPreDua = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private solicitudService: SolicitudService,
        private preduaService: PreduaService,
        private productosService: ProductosService,
        private navMenuService: NavMenuService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudPredua = new TMedioTransportePreDuaViewModel();
        //this.partidas = this.predua.TPartidasPreduaList;

        //this.predua.TPartidasPreduaList = new Array<TPartidaPreduaViewModel>();
    }

    ngOnInit() {
        this.cols = [
            { field: 'ExpandLink', header: '' },
            //{ field: 'Link', header: '' },
            { field: 'Partida', header: 'Partida' },
            { field: 'CodigoTaric', header: 'Código Taric' },
            { field: 'PaisOrigen', header: 'País Origen' },
            { field: 'PesoNeto', header: 'Peso (kg)' },
            { field: 'Acumulado', header: 'Acumulado' },
            { field: 'DescripcionMercancia', header: 'Descripción Mercancía' },
            { field: 'strMatriculas', header: 'Matrí­culas' },
        ];

        this.selectedColumns = this.cols;

        //this.cols2 = [
        //    //{ field: 'Id', header: 'Id', display: 'none' },
        //    { field: 'IdSolicitud', header: 'N. Solicitud' },
        //    { field: 'CodigoTaric', header: 'Código Taric' },
        //    { field: 'IdPaisDescripcion', header: 'País' },
        //    { field: 'Peso', header: 'Peso (kg)' },
        //    { field: 'IdBotanicaDescripcion', header: 'N. Botánico' },
        //    { field: 'NombreComun', header: 'N. común' },
        //    { field: 'Grupo', header: 'Grupo' },
        //    { field: 'IdFormaDescripcion', header: 'Forma' },
        //];

        //this.selectedColumns2 = this.cols2;

        this.globalService.getTipoOperacionAduanas().subscribe(res => {
            this.listOperacion = res;
        });

        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);

        this.createForm();

        if (this.idSolicitud) {
            this.loading = true;

            //recuperar la solicitud
            this.preduaService.getSolicitudPreduaById(this.idSolicitud).subscribe(result => {
                this.solicitudPredua = result;

                this.CodigoSolicitud = this.solicitudPredua.TSolicitud.CodigoSolicitud;
                this.CodigoTipoSolicitud = this.solicitudPredua.TSolicitud.CodigoTipoSolicitud;
                this.IdEstadoSolicitud = this.solicitudPredua.TSolicitud.IdEstadoSolicitud;
                this.TipoSolicitudDescripcion = this.solicitudPredua.TSolicitud.IdTipoSolicitudDescripcion;
                this.EstadoSolicitudDescripcion = this.solicitudPredua.TSolicitud.IdEstadoSolicitudDescripcion;
                this.EsPredua = this.solicitudPredua.TSolicitud.EsPredua;
                this.mrn = this.solicitudPredua.Mrn;

                //SI ES RE-IMPORTACION
                if (this.solicitudPredua.TSolicitud.EsReImportacion) {
                    this.TipoSolicitudDescripcion += ' - Re-Importación';
                }

                this.partidas = this.solicitudPredua.TPredua.TPartidasPreduaList;
                this.solicitudPredua.TPredua.TPartidasPreduaList.forEach(partidaPredua => {
                    let first = true;
                    this.strMatriculas = '';

                    partidaPredua.MatriculasList.forEach(t => {
                        //Matrí­culas
                        if (!first) {
                            this.strMatriculas += ', ' + t.Matricula;
                        } else {
                            this.strMatriculas += t.Matricula;
                            first = false;
                        }
                    });

                    partidaPredua.strMatriculas = this.strMatriculas;

                    //Pesos
                    //Llamada automática recuperar partidas relacionadas mismo MRN
                    this._parametros = '?id=' + this.solicitudPredua.TSolicitud.Id + '&mrn=' + this.mrn + '&partida=' + partidaPredua.Partida;

                    let partidasPesoAcumulado: number = 0;

                    this.productosService.getSolicitudPartidasPredua(this._parametros).subscribe(productosSolicitud => {
                        productosSolicitud.forEach(productoSolicitud => {
                            this.partidas.forEach(partida => {
                                if (productoSolicitud.Partida === partida.Partida) {
                                    if (partida.SolicitudPartidasPreduaList === null || partida.SolicitudPartidasPreduaList === undefined) {
                                        partida.SolicitudPartidasPreduaList = [];
                                    }
                                    partida.SolicitudPartidasPreduaList.push(productoSolicitud);
                                    partidasPesoAcumulado += productoSolicitud.Peso!;
                                    partida.Acumulado = partidasPesoAcumulado;
                                }
                            });
                        });
                    });
                });

                this.solicitudPredua = result;

                this.updateForm();

                this.form.controls['IdOperacion'].disable();

                this.posicionamientopredua = result.TPredua.TPosicionamientoPreduaList;

                this.loading = false;
            });
        }
    }

    //cargar subgrid
    onRowExpand(selectedIndex: any) {
        //this._acumulado = 0;
        //this._parametros = '?id=' + this.solicitud.Id + '&mrn=' + this.mrn + '&partida=' + selectedIndex.data.Partida;
        //this.listSolicitudPartidasPreduaCollection$ = this.productosService.getSolicitudPartidasPredua(this._parametros);
        //this.listSolicitudPartidasPreduaCollection$.subscribe(s => {
        //    s.forEach(t => {
        //        this._acumulado += t.Peso!;
        //    });
        //    //this.partidas[selectedIndex.data.Id].Acumulado = this._acumulado;
        //    //this.partidas.splice .partidas(x => x. [selectedIndex.data.Id].Acumulado = this._acumulado;
        //    this.partidas[0].Acumulado = 222;
        //});
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Mrn: '',
            IdOperacion: null,
            IdPif: null,
            IdPifDescripcion: '',
            IdAduanaDespacho: null,
            IdAduanaDespachoDescripcion: '',
            NombreExportador: '',
            PaisExportador: null,
            CiudadExportador: '',
            DireccionExportador: '',
            IdentificadorImportador: null,
            RazonSocialImportador: '',
            DireccionImportador: '',
            PaisDestino: null,
            PaisOrigen: null,
            MedioTransporte: null,
            FechaCreacion: '',
            FechaModificacion: '',
            FechaImportacion: '',
            FechaPresentacion: '',
            //IdBandejaEntrada: [null, Validators.required]
        });
    }

    updateForm() {
        this.form.setValue({
            Mrn: this.solicitudPredua.Mrn,
            IdOperacion: this.solicitudPredua.TPredua.IdOperacion,
            IdPif: this.solicitudPredua.TPredua.IdPif,
            IdPifDescripcion: this.solicitudPredua.TPredua.IdPifDescripcion,
            IdAduanaDespacho: this.solicitudPredua.TPredua.IdAduanaDespacho,
            IdAduanaDespachoDescripcion: this.solicitudPredua.TPredua.IdAduanaDespachoDescripcion,
            NombreExportador: this.solicitudPredua.TPredua.NombreExportador,
            //IdPaisExportador: this.predua.IdPaisExportador,
            PaisExportador: this.solicitudPredua.TPredua.PaisExportador,
            CiudadExportador: this.solicitudPredua.TPredua.CiudadExportador,
            DireccionExportador: this.solicitudPredua.TPredua.DireccionExportador,
            IdentificadorImportador: this.solicitudPredua.TPredua.IdentificadorImportador,
            RazonSocialImportador: this.solicitudPredua.TPredua.RazonSocialImportador,
            DireccionImportador: this.solicitudPredua.TPredua.DireccionImportador,
            //IdPaisDestino: this.predua.IdPaisDestino,
            PaisDestino: this.solicitudPredua.TPredua.PaisDestino,
            //IdPaisOrigen: this.predua.IdPaisOrigen,
            PaisOrigen: this.solicitudPredua.TPredua.PaisOrigen,
            //IdMedioTransporte: this.predua.IdMedioTransporte,
            MedioTransporte: this.solicitudPredua.TPredua.MedioTransporte,
            FechaCreacion: new Date(this.solicitudPredua.TPredua.FechaCreacion),
            FechaModificacion: new Date(this.solicitudPredua.TPredua.FechaModificacion),
            FechaImportacion: new Date(this.solicitudPredua.TPredua.FechaImportacion),
            FechaPresentacion: new Date(this.solicitudPredua.TPredua.FechaPresentacion),
            //IdBandejaEntrada: this.predua.IdBandejaEntrada,
        });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.solicitudService.currentIdSolicitud]);
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.isCollapsedExportador = false;
            this.isCollapsedImportador = false;
            this.isCollapsedLugaresMercancia = false;
            this.isCollapsedOtrosDatos = false;
            this.isCollapsedDatosPreDua = false;
            this.isCollapsedContenedores = false;
            this.isCollapsedPartidasPreDua = false;

            return;
        }

        //let predua = new SolicitudPreduaViewModel();

        //previa.IdSolicitud = this.solicitud.Id;
        //previa.IdInspector = this.form.value.IdInspector;
        //previa.Aceptada = (this.form.value.Aceptada == 'S') ? true : false;
        //previa.Fecha = this.form.value.Fecha;
        //previa.Observaciones = this.form.value.Observaciones;
        //previa.IgnorarMirala = this.form.value.IgnorarMirala;

        //if (!this.esPreduaExistente) {

        //    previa.Fecha = new Date();

        //    this.previaInspectorService.createPrevia(previa)
        //        .subscribe(res => {
        //            this.addSuccessMessage("Solicitud previa añadida correctamente");
        //            this.onBack();
        //        }, error => {
        //            this.catchServerError(error);
        //        }
        //        );
        //}
    }
}
